module.exports = __webpack_public_path__ + "img/balance.fb8423a3.png";